import {
  curry,
  concat as concatPairs,
  pipe,
  toUpper,
  includes,
  last,
  split,
  slice,
  endsWith,
} from 'ramda'
import { modifyParams } from './function'

export const concat = (...strings: (string | number)[]): string => {
  const [str1, str2, ...rest] = strings.map(String)

  if (strings.length === 1) return str1

  return concat(concatPairs(str1, str2), ...rest)
}
export const capitalize = (input: string): string => {
  const str = String(input)
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const includesIgnoringCase = curry(
  (pattern: string, string: string): boolean =>
    modifyParams(includes, pipe(String, toUpper), [pattern, string]),
)

export const pluralize = (
  count: number,
  singular: string,
  plural: string,
  showCount: boolean = true,
): string => {
  const text = count !== 1 ? plural : singular
  return showCount ? `${count} ${text}` : text
}

export const splitAtLastIndex = curry((char: string, str: string): [
  string,
  string,
] => {
  if (!str.includes(char) || endsWith(char, str)) return [str, '']

  const splitted = split(char, str)
  return [slice(0, -1, splitted).join(' '), last(splitted) ?? '']
})

type Address = {
  street: string
  streetNr: string | number
  postalCode: string | number
  city: string
}

export const makeAddress = ({
  street,
  streetNr,
  postalCode,
  city,
}: Address): string => `${street} ${streetNr}, ${postalCode} ${city}`
